import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import EditIcon from "../../../common/Icons/EditIcon";

import styles from "./edit-button.module.scss";

function EditButton({path, className}) {
  return (
    <div className={classNames(className, styles.root)}>
      <a href={path} className={styles.title}>
        <span className={styles.icon}>
          <EditIcon />
        </span>
        Изменить дизайн
      </a>
    </div>
  );
}

EditButton.propTypes = {
  path: PropTypes.string,
  className: PropTypes.string
};

export default EditButton;
